import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  imports: [NgClass],
  template: `
    <button
      [type]="htmlType"
      (click)="onClick.emit($event)"
      [ngClass]="type"
      [disabled]="disabled"
    >
      <ng-content></ng-content>
    </button>
  `,
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() disabled: boolean = false;
  @Input() type:
    | 'bouton'
    | 'discreet'
    | 'warn'
    | 'danger'
    | 'get-started'
    | 'menu'
    | 'submit'
    | 'reset'
    | 'waiting-response' = 'bouton';
  @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  get htmlType(): 'button' | 'submit' | 'reset' {
    // Seuls les types submit et reset ont un comportement spécial, sinon on utilise button
    if (this.type === 'submit') return 'submit';
    if (this.type === 'reset') return 'reset';
    return 'button';
  }
}
